import * as React from 'react';
import { IconProps } from './types';

export function CurvedArrowIcon(props: IconProps) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
			<path
				stroke="#D9D9D9"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={props.strokeWidth ?? 1.15}
				d="M1.667 11.05h.622c4.106 0 6.16 0 7.435-1.378C11 8.293 11 6.075 11 1.638V.65"
			/>
			<path
				stroke="#D9D9D9"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth={props.strokeWidth ?? 1.15}
				d="m3 9.1-1.266 1.234c-.345.337-.518.505-.518.716 0 .21.173.38.518.716L3 13"
			/>
		</svg>
	);
}
